import React from "react";
import ChatMediaContent from "./ChatMediaContent";
import Scaffold from "../../../widget/layouts/Scaffold";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import {
  ChatMediaContextImport,
  ChatMediaContextProvider,
} from "../../../provider/chats/chats/chat_media/ChatMediaContextProvider";
import ChatMediaActions from "./widget/ChatMediaActions";
import { IconNormal } from "../../../widget/common/ui/Icon";
import AppTheme from "../../../service/app_config/AppTheme";

const ChatMediaScreen = () => {
  return (
    <ChatMediaContextProvider>
      <ChatMediaScreenBody />
    </ChatMediaContextProvider>
  );
};

export default ChatMediaScreen;

const ChatMediaScreenBody = () => {
  const { longPressStatus, clearLongPress, mediaIdsSelected } =
    ChatMediaContextImport();

  const cancelSelectionHtml: JSX.Element = (
    <div className="d-flex align-items-center">
      <IconNormal
        name="close"
        color={AppTheme.themeFont}
        handleClick={() => clearLongPress()}
      />
      <span className="ps-3 font-gotham-bold font-size-18_20 color-theme-font">
        {mediaIdsSelected.length}
      </span>
    </div>
  );

  return (
    <Scaffold
      appBarTitle={AppTranslation.text(longPressStatus ? "" : "media")}
      appBarArrow={longPressStatus ? cancelSelectionHtml : undefined}
      appBarAction={<ChatMediaActions />}
      isModal={true}
    >
      <ChatMediaContent viewType="modal" />
    </Scaffold>
  );
};
